import { Box, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { memo } from 'react';
import { StatusNextGemLabelProps } from './StatusNextGemLabel.types';
import { formatNumber } from '@bonanza-social/toolkit/utils';

function StatusNextGemLabel({
  currentPoints,
  totalPoints,
  playerStatus,
}: StatusNextGemLabelProps) {
  const [t] = useTranslation('status');

  return (
    <Box
      zIndex={10}
      position="absolute"
      bottom="-space-200"
      backgroundColor="backdropPrimary"
      paddingHorizontal="space-200"
      paddingVertical="space-100"
      borderRadius="radius-200"
      alignItems="center"
    >
      <Text
        variant="overline"
        locNS="status"
        locKey={
          playerStatus === 'Member' ? 'statusUnlockStatus' : 'statusNextGem'
        }
        color="darkSurfacePrimary"
        textAlign="center"
        numberOfLines={1}
      />
      <Text variant="caption" color="darkSurfacePrimary">
        {t('statusNextGemPoints', {
          current: formatNumber(currentPoints),
          total: formatNumber(totalPoints),
        })}
      </Text>
    </Box>
  );
}

export default memo(StatusNextGemLabel);
